import { render, staticRenderFns } from "./task-wrapper.vue?vue&type=template&id=339d8eda&lang=pug&"
import script from "./task-wrapper.vue?vue&type=script&lang=js&"
export * from "./task-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports